import React, { useState, useEffect } from 'react'
import { getSystemMessage } from '@/services/common'
import { Alert } from 'antd'
import Marquee from 'react-fast-marquee';
import './index.scss'
import type { SystemMessage } from '@/services/common/types'

const CarouselMessage = () => {
  const [visible, setVisible] = useState(false)
  const [msg, setMsg] = useState<SystemMessage>()

  /**
   * @desc 获取系统维护通知
   */
  const getData = async () => {
    try {
      const res = await getSystemMessage()
      if (!res?.id || !res.content) {
        return
      }
      let _visible = true
      const flag = localStorage.getItem('systemMessage' + res.id)
      // id变化表示有新的系统消息，直接显示， id不变表示是旧消息，判断是否显示
      if (flag) {
        _visible = flag === 'show'
      }
      if (res.content) {
        setVisible(_visible)
        setMsg(res)
        localStorage.setItem('systemMessage' + res.id, _visible ? 'show' : 'hide')
      }
    } catch (error) {
      console.log('获取系统维护通知', error)
    }
  }
  useEffect(() => {
    getData()
  }, [])

  /**
   * @desc 点击隐藏组件
   */
  const onClose = () => {
    localStorage.setItem('systemMessage' + msg.id, 'hide')
    // setVisible(false)
  }
  return (
    visible && <Alert
      banner
      title={
        <Marquee pauseOnHover gradient={false}>
          {msg?.content}
        </Marquee>
      }
      showIcon={false}
      closable={{
        closeIcon: true,
        afterClose: onClose,
      }}
      classNames={{
        root: 'carouselMessage-container'
      }}
    />
  )
}

export default CarouselMessage
